import type { TableRequestBody, TableRequestColumns } from '@ipfabric/utils';
import type { CloudNetworkDetailData } from './CloudNetworkDetailContent';

interface RequestPayload {
  networkId: string;
  snapshotId: string;
}

interface CloudNetworksRequest {
  url: string;
  method: string;
  data: TableRequestBody<CloudNetworkDetailData>;
}

export const getCloudNetworkDetailRequestPayload = ({
  networkId,
  snapshotId,
}: RequestPayload): CloudNetworksRequest => {
  const columns: TableRequestColumns<CloudNetworkDetailData> = [
    'cloudProvider',
    'networkId',
    'name',
    'resourceName',
    'state',
    'region',
    'ipv4CidrBlocks',
    'ipv6CidrBlocks',
    'peeringCount',
  ];
  return {
    url: '/tables/cloud/networks/inventory',
    method: 'POST',
    data: {
      columns,
      filters: { networkId: ['eq', networkId] },
      snapshot: snapshotId,
    },
  };
};
